import { faSpinnerThird } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import styles from './Spinner.module.sass';

const Spinner = () => {
    return <div className={styles['spinner']}>
        <FontAwesomeIcon icon={faSpinnerThird} size='3x'/>
    </div>
}

export default Spinner